module.exports = __webpack_public_path__ + "static/Symphonia6-cc44aefc00f2b06eb0da6e0070b4d240.png";